import React from 'react'

import Breakpoint from 'components/Common/Breakpoint'
import DesktopAccommodationDateTimeFields from './DesktopAccommodationDateTimeFields'
import MobileAccommodationDateTimeFields from './MobileAccommodationDateTimeFields'

export function AccommodationDateTimeFields() {
  return (
    <>
      <Breakpoint max="mobile">
        <MobileAccommodationDateTimeFields />
      </Breakpoint>
      <Breakpoint min="tablet">
        <DesktopAccommodationDateTimeFields />
      </Breakpoint>
    </>
  )
}
